<template>
  <div>
    <EsHeaderView />
    <div class="container-box">
      <div class="app-container">
        <div class="flash-header">
          <span class="flash-title">⚡ {{ $t('message.home.flashSale') }}</span>
          <div class="countdown-wrap" v-if="timeLeft">
            <span class="countdown-label">{{ $t('message.home.endsIn') }}：</span>
            <span class="countdown-block">{{ timeLeft.h }}</span>:
            <span class="countdown-block">{{ timeLeft.m }}</span>:
            <span class="countdown-block">{{ timeLeft.s }}</span>
          </div>
        </div>
        <div class="seckill-tabs">
          <div v-for="tab in tabTimes" :key="tab.id" :class="['seckill-tab', tabindex===tab.id?'active':'']" @click="switchTab(tab)">
            <div class="tab-time">{{ tab.time }}</div>
            <div class="tab-name">{{ tab.name }}</div>
          </div>
        </div>
        <div v-loading="loading">
          <div class="goods-grid" v-if="list.length">
            <div class="goods-card" v-for="(item, index) in list" :key="(item.marketingId || '') + '-' + (item.goodsId || item.id || '') + '-' + index" @click="goDetail(item)">
              <div class="sale-badge">{{ $t('message.home.flashSale') }}</div>
              <img :src="(item.goods && item.goods.thumbnail) || item.image" class="goods-img" />
              <div class="goods-name">{{ (item.goods && item.goods.name) || item.name }}</div>
              <div class="price-row">
                <span class="sale-price">¥{{ item.marketingPrice || item.price }}</span>
                <span class="origin-price" v-if="item.goods && item.goods.marketPrice">¥{{ item.goods.marketPrice }}</span>
              </div>
              <el-button type="danger" size="small" style="width:100%;margin-top:10px">
                {{ $t('message.home.buyNow') }}
              </el-button>
            </div>
          </div>
          <el-empty v-if="!list.length && !loading" :description="$t('message.home.noData')" />
        </div>
      </div>
    </div>
    <EsFooterView />
  </div>
</template>

<script>
import { list } from '@/api/marketing/seckill_marketing'

export default {
  name: 'FlashSalePage',
  data() {
    return { loading: false, list: [], timeLeft: null, timer: null, tabTimes: [], tabindex: 1 }
  },
  created() {
    this.buildTabTimes()
    this.startCountdown()
    this.loadData()
  },
  beforeDestroy() { if (this.timer) clearInterval(this.timer) },
  methods: {
    //生成4个时段Tab：当前小时 + 后续3小时
    buildTabTimes() {
      const hourNames = ['ZERO','ONE','TWO','THREE','FOUR','FIVE','SIX','SEVEN','EIGHT','NINE','TEN','ELEVEN','TWELVE','THIRTEEN','FOURTEEN','FIFTEEN','SIXTEEN','SEVENTEEN','EIGHTEEN','NINETEEN','TWENTY','TWENTY_ONE','TWENTY_TWO','TWENTY_THREE']
      const nowHour = new Date().getHours()
      const tabs = []
      for (let i = 0; i < 4; i++) {
        const h = (nowHour + i) % 24
        tabs.push({
          id: i + 1,
          time: h + ':00',
          name: i === 0 ? this.$t('message.home.seckillRushing') : this.$t('message.home.seckillWillStart'),
          hour: hourNames[h],
        })
      }
      this.tabTimes = tabs
    },
    switchTab(tab) {
      this.tabindex = tab.id
      this.startCountdown()
      this.loadData()
    },
    loadData() {
      this.loading = true
      const hour = this.tabTimes[this.tabindex - 1] ? this.tabTimes[this.tabindex - 1].hour : 'ZERO'
      list({ pageNumber: 1, pageSize: 50, hour }).then(r => {
        const data = r.data?.data
        this.list = Array.isArray(data) ? data : (data?.data || data?.content || [])
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    //倒计时到当前选中场次（小时）结束，而非活动整体有效期
    startCountdown() {
      if (this.timer) clearInterval(this.timer)
      const now = new Date()
      const endOfSlot = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours() + this.tabindex, 0, 0, 0)
      this.timer = setInterval(() => {
        const diff = endOfSlot - Date.now()
        if (diff <= 0) { clearInterval(this.timer); this.timeLeft = null; return }
        const h = String(Math.floor(diff / 3600000)).padStart(2, '0')
        const m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0')
        const s = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0')
        this.timeLeft = { h, m, s }
      }, 1000)
    },
    goDetail(item) {
      this.$router.push({ path: '/productDetails', query: {
        id: item.goodsId || item.id,
        marketingId: item.marketingId,
        marketingModeId: 'seckillMarketing',
        seckillable: this.tabindex === 1 ? 'true' : 'false'
      }})
    }
  }
}
</script>

<style lang="scss" scoped>
.container-box { background: #f5f5f5; min-height: calc(100vh - 120px); }
.app-container { width: 1200px; margin: 0 auto; padding: 30px 0; }
.flash-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 24px; }
.flash-title { font-size: 24px; font-weight: bold; color: #f56c6c; }
.countdown-wrap { display: flex; align-items: center; gap: 4px; font-size: 14px; color: #606266; }
.countdown-block { background: #303133; color: #fff; padding: 4px 8px; border-radius: 4px; font-weight: bold; }
.goods-grid { display: grid; grid-template-columns: repeat(5, 1fr); gap: 16px; }
.goods-card { background: #fff; border-radius: 8px; overflow: hidden; padding: 12px; cursor: pointer; position: relative; transition: box-shadow .2s; &:hover { box-shadow: 0 4px 16px rgba(0,0,0,.1); } }
.sale-badge { position: absolute; top: 0; left: 0; background: #f56c6c; color: #fff; font-size: 11px; padding: 2px 8px; border-radius: 0 0 8px 0; }
.goods-img { width: 100%; aspect-ratio: 1; object-fit: cover; border-radius: 4px; }
.goods-name { font-size: 13px; color: #303133; margin: 8px 0 6px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.price-row { display: flex; align-items: baseline; gap: 8px; }
.sale-price { font-size: 20px; font-weight: bold; color: #f56c6c; }
.origin-price { font-size: 12px; color: #c0c4cc; text-decoration: line-through; }
.seckill-tabs { display: flex; gap: 8px; margin-bottom: 20px; }
.seckill-tab {
  width: 90px; text-align: center; padding: 6px 0;
  border-radius: 4px; background: #fff; cursor: pointer; color: #999;
  .tab-time { font-size: 13px; font-weight: bold; }
  .tab-name { font-size: 11px; }
  &.active { background: linear-gradient(90deg, #ee0a24, #ff6034); color: #fff; }
}
</style>
